import { UAParser } from 'ua-parser-js';

export function getUserAgentInfo() {
  try {
    const parser = new UAParser(window.navigator.userAgent);

    return parser.getResult();
  } catch (e) {
    console.log('getUserAgentInfo()', e);
  }

  return null;
}
